export const isSocketSupported = () => typeof WebSocket !== 'undefined' && typeof fetch !== 'undefined';

export const toInboundText = async (data: MessageEvent['data']): Promise<string | null> => {
  if (typeof data === 'string') {
    return data;
  }

  if (typeof Blob !== 'undefined' && data instanceof Blob) {
    return data.text();
  }

  if (typeof ArrayBuffer !== 'undefined' && data instanceof ArrayBuffer) {
    return new TextDecoder().decode(data);
  }

  return null;
};

export const buildAvailabilitySocketUrl = (apiBaseUrl: string, webSocketUrl: string) => {
  const url = new URL(webSocketUrl, apiBaseUrl);

  if (url.protocol === 'https:') {
    url.protocol = 'wss:';
  } else if (url.protocol === 'http:') {
    url.protocol = 'ws:';
  }

  return url.toString();
};
